import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { cn } from "@/lib/utils";
import { TONES } from "@/lib/status";

// Card de métrica denso: ícone, rótulo, valor grande, dots/trend, chevron opcional.
export const StatCard = ({ icon: Icon, label, value, dots = [], trend, accent = false, to, className }) => {
  const inner = (
    <div
      data-testid={`stat-card-${label}`}
      className={cn(
        "group relative flex h-full min-h-[132px] flex-col overflow-hidden rounded-xl border bg-surface p-4 card-grad transition-all duration-300",
        "hover:bg-surface-hover hover:-translate-y-0.5",
        accent ? "border-brand/30 hover:glow-red-sm" : "border-line hover:border-line/80",
        className,
      )}
    >
      <span
        className={cn(
          "absolute inset-x-0 top-0 h-px",
          accent ? "bg-gradient-to-r from-transparent via-brand to-transparent opacity-70" : "bg-white/5",
        )}
      />
      <div className="flex items-start justify-between">
        <div className={cn("flex h-9 w-9 shrink-0 items-center justify-center rounded-lg", accent ? "bg-brand/15 text-brand" : "bg-white/5 text-muted-foreground")}>
          {Icon && <Icon className="h-[18px] w-[18px]" />}
        </div>
        {to && <ChevronRight className="h-4 w-4 shrink-0 text-muted-foreground/50 transition-transform group-hover:translate-x-0.5 group-hover:text-muted-foreground" />}
      </div>
      <div className="mt-3">
        <p className="truncate text-[13px] font-medium text-muted-foreground">{label}</p>
        <div className="mt-0.5 flex flex-wrap items-baseline gap-x-2">
          <span className="font-heading text-3xl font-bold tracking-tight text-foreground">{value}</span>
          {trend && (
            <span className={cn("text-xs font-medium", TONES[trend.tone]?.text || "text-muted-foreground")}>{trend.value}</span>
          )}
        </div>
      </div>
      <div className="mt-auto flex min-h-[20px] flex-wrap items-center gap-x-3 gap-y-1 pt-3">
        {dots.map((d, i) => (
          <span key={i} className="inline-flex items-center gap-1.5 text-[11px] text-muted-foreground">
            <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", TONES[d.tone]?.dot)} />
            {d.label}
          </span>
        ))}
      </div>
    </div>
  );
  return to ? <Link to={to} className="block h-full">{inner}</Link> : inner;
};
